










































































import {
  Component, Prop, Mixins,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import GeneralModule from '@/store/modules/General';
import BankAccountModule from '@/store/modules/BankAccount';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import AuthModule from '@/store/modules/Auth';
import utils from '@/services/utils';

@Component
export default class PointBody extends Mixins(
  ErrorHandleMixin,
) {
  GeneralInstance = getModule(GeneralModule, this.$store);

  BankAccountInstance = getModule(BankAccountModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  @Prop() readonly data: any;

  @Prop() readonly fetchPointAgent!: Function;

  @Prop() readonly footSummery!: object;

  utilsInstance = utils;

  handleSub(data: object) {
    this.fetchPointAgent(data);
  }
}
